__turbopack_context__.v({
  "FeedbackForm--Loading": "lUxlLW_FeedbackForm--Loading",
  "FeedbackForm__Error": "lUxlLW_FeedbackForm__Error",
  "FeedbackForm__Field": "lUxlLW_FeedbackForm__Field",
  "FeedbackForm__Form": "lUxlLW_FeedbackForm__Form",
  "FeedbackForm__Row": "lUxlLW_FeedbackForm__Row",
  "FeedbackForm__Row--Half": "lUxlLW_FeedbackForm__Row--Half",
  "FeedbackForm__Success": "lUxlLW_FeedbackForm__Success",
});
